import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
export var BlankSteps = React.forwardRef(function BlankSteps(_a, ref) {
    var _b = _a.steps, steps = _b === void 0 ? [] : _b, className = _a.className, props = __rest(_a, ["steps", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-blank-page-v2__step", className) }, props), steps.map(function (step, index) { return (React.createElement("div", { className: "item", key: index },
        React.createElement("i", { className: "num" }, index + 1),
        step)); })));
});
BlankSteps.displayName = "BlankSteps";
//# sourceMappingURL=BlankSteps.js.map